module.exports = __webpack_public_path__ + "static/preview2-bdf9c34848bd77b7400142f2be28feb3.jpg";